import React from 'react';

interface CoefficientProps {
    odd?: number;
    direction?: 'up' | 'down';
}

function Coefficient(props: CoefficientProps) {
    switch (props.direction) {
        case 'down':
            return (
                <div className="rounded-[8px] py-[5px] px-2 desktop:py-[7px] text-[12px] desktop:text-[16px] font-['Roboto'] leading-[100%] desktop:px-[18px] bg-[#16181B] text-[#FF2D2D] border border-[#EACD40]">
                    {props.odd && props.odd.toFixed(2)}
                </div>
            );
        case 'up':
            return (
                <div className="rounded-[8px] py-[5px] px-2 text-[12px] desktop:text-[16px] font-['Roboto'] leading-[100%] desktop:py-[7px] desktop:px-[18px] bg-[#16181B] text-[#2FF36B] border border-[#EACD40]">
                    {props.odd && props.odd.toFixed(2)}
                </div>
            );
        default:
            return (
                <div className="rounded-[8px] py-[5px] px-2 text-[12px] desktop:text-[16px] font-['Roboto'] leading-[100%] desktop:py-[7px] desktop:px-[18px] bg-[#16181B] text-white border border-[#EACD40]">
                    {props.odd && props.odd.toFixed(2)}
                </div>
            );
    }
}

export default Coefficient;
